export default "__VITE_ASSET___ILeHNrW__"